import { Directive, Input, TemplateRef, inject } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'ng-template[cell]',
  standalone: false,
})
export class TableCellDirective {
  templateRef = inject<TemplateRef<any>>(TemplateRef);

  @Input() cell?: string;

  @Input() columnTitle?: string;

  @Input() sortingDisabled = false;

  @Input() hideLtMd?: boolean;

  @Input() hideLtSm?: boolean;
}
